import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { SectionHeading } from './Shared';
const faqs = [{
  q: '¿Cómo recibo el kit?',
  a: 'Después de realizar la compra, el acceso al kit completo y a los bonus llega de forma inmediata al correo electrónico que indiques en el checkout. Vas a poder descargar todo el material para usarlo en consulta o entregarlo al paciente según corresponda.\n\nRevisá tu bandeja de entrada (y la carpeta de spam o promociones por las dudas) apenas finalices la compra.'
}, {
  q: '¿Sirve para cualquier tipo de terapia?',
  a: 'Sí. El kit está diseñado como una herramienta práctica para psicólogos y terapeutas que quieran abordar el insomnio dentro de su proceso clínico. Podés adaptarlo a distintos enfoques terapéuticos, especialmente si trabajás con pacientes con ansiedad, estrés, depresión, burnout o rumiación nocturna.'
}, {
  q: '¿Todos los bonos están incluidos?',
  a: 'Sí. Con tu compra accedés al kit principal y a los 3 bonus profesionales:\n\n• Protocolo de Psicoeducación sobre el Sueño.\n• Diario de Sueño del Paciente.\n• Guía de Higiene del Sueño.\n\nNo tenés que pagar extra por los bonus incluidos en esta oferta.'
}, {
  q: '¿Qué métodos de pago están disponibles?',
  a: 'El pago se procesa de forma segura a través de Mercado Pago. Podés abonar con:\n\n• Tarjetas de crédito (Visa, Mastercard, American Express, Cabal, Naranja y otras habilitadas).\n• Tarjetas de débito.\n• Dinero disponible en tu cuenta de Mercado Pago.\n• Transferencia o pago en efectivo en puntos habilitados (Pago Fácil, Rapipago).\n\nSegún el medio de pago elegido, podrías acceder a cuotas sin interés disponibles en Mercado Pago.'
}, {
  q: '¿Por qué elegir este kit?',
  a: 'Porque te permite abordar el insomnio con más estructura clínica, sin tener que crear desde cero protocolos, materiales para pacientes, diarios de sueño o guías psicoeducativas.\n\nEs un recurso práctico para detectar, intervenir y acompañar el insomnio dentro del tratamiento psicológico real.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-white" data-id="element-43">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-44">
        <SectionHeading data-id="element-45">PREGUNTAS FRECUENTES</SectionHeading>

        <div className="space-y-4" data-id="element-46">
          {faqs.map((faq, index) => <div key={index} className="border border-slate-200 rounded-2xl overflow-hidden bg-slate-50" data-id="element-47">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-48">
                <span className="font-serif font-bold text-lg text-navy pr-8" data-id="element-49">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-gold flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-50" />
              </button>

              <AnimatePresence data-id="element-51">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-52">
                    <div className="p-6 pt-0 text-slate-600 whitespace-pre-line leading-relaxed" data-id="element-53">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}